import { useQuery } from "@tanstack/react-query";

import Axios from "@/lib/axios-instance";

export const getMembers = async () => {
    try {
        const response = await Axios.get(`/users/members`);
        return response.data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        if (error.response) {
            return error?.response?.data;
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useGetMembers = () => {
    const user = useQuery({ queryKey: ["get-all-members"], queryFn: getMembers });

    return user;
};
